import { useEffect, useState } from "react";
import { ITaskProblemDetails } from "models/tasks";
import useCentralApi from "hooks/shared/useCentralApi";
import { useCurrentUser } from "hooks/shared";

type GetTaskProblemDetailsResult = {
    hasViewProblemLogPermission: boolean,
    hasAddProblemFlagPermission: boolean,
    hasRemoveProblemFlagPermission: boolean,
    problemDetails : ITaskProblemDetails[],
    totalItems: number
}

type TaskProblemDetailsResult = [
    ITaskProblemDetails[],
    number,
    boolean,
    string | null,
    boolean,
    boolean,
    boolean,
];

const useTaskProblemDetails: (taskId: number | undefined, manualUpdate?: boolean) => TaskProblemDetailsResult = (taskId: number | undefined, manualUpdate: boolean = false) => {
    const [ _lastQuery, _setLastQuery ] = useState<string>('');
    const [ result, setResult ] = useState<ITaskProblemDetails[]>([]);
    const [ total, setTotal ] = useState<number>(0);
    const [ hasViewProblemLogPermission, setHasViewProblemLogPermission ] = useState<boolean>(false);    
    const [ hasAddProblemFlagPermission, setHasAddProblemFlagPermission ] = useState<boolean>(false);    
    const [ hasRemoveProblemFlagPermission, setHasRemoveProblemFlagPermission ] = useState<boolean>(false);    
    const [ error, setError ] = useState<string | null>(null);
    const [ loading, setLoading ] = useState<boolean>(true);    
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    useEffect(() => {
        const query = `/api/v3/tasks/${taskId}/problemdetails`;
        if (_lastQuery === query && !manualUpdate) return;
        setLoading(true);
        const controller = new AbortController();
        if ((taskId && taskId != 0 && taskId != undefined)) {
            (async () => {
                try {
                    const resp = await fetcher(query, {
                        signal: controller.signal
                    });

                    if (!resp.ok) {
                        // RESPOND TO ERRORS
                    }
                    const data = await resp.json() as GetTaskProblemDetailsResult;
                    setResult(data.problemDetails);
                    setHasViewProblemLogPermission(data.hasViewProblemLogPermission);
                    setHasAddProblemFlagPermission(data.hasAddProblemFlagPermission);
                    setHasRemoveProblemFlagPermission(data.hasRemoveProblemFlagPermission);

                    if (data.totalItems !== total) {
                        setTotal(data.totalItems);
                    }

                    _setLastQuery(query);
                } catch (err) {

                } finally {
                    setLoading(false);
                }
            })(); 
        } else {
            setLoading(false);
        }

        return () => controller.abort();
    }, [ user, taskId, manualUpdate]);

    return [
        result,
        total,
        loading,
        error,
        hasViewProblemLogPermission,
        hasAddProblemFlagPermission,
        hasRemoveProblemFlagPermission
    ];
};

export default useTaskProblemDetails;